import { Button, Stack, Typography, useTheme } from "@mui/material";
import AddRounded from "@mui/icons-material/AddRounded";
import { tokens } from "../../../../../../../theme";

interface SectionHeaderProps {
  title: string;
  action?: string;
  onAction?: () => void;
}

export default function SectionHeader({
  title,
  action,
  onAction,
}: SectionHeaderProps) {
  const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 2 }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: "15px", color: colors.primary[100] }}>
        {title}
      </Typography>
      {action && (
        <Button
          onClick={onAction}
          startIcon={<AddRounded sx={{ fontSize: 14 }} />}
          sx={{
            border: `1px solid ${colors.primary[500]}`,
            borderRadius: "20px",
            px: 2,
            py: 0.5,
            textTransform: "none",
            fontSize: "12px",
            color: colors.primary[500],
            fontWeight: 500,
            "&:hover": { bgcolor: "background.paper" },
          }}
        >
          {action}
        </Button>
      )}
    </Stack>
  );
}
